import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import Toggle from 'react-bootstrap-toggle';
import { Button, FormGroup, ControlLabel, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { fetchEmergencySettings, updateEmergencySettings } from '../../AdminActions';
import ProgressBar2 from '../../../../components/progress-bar';
import DateTimeDisplay from '../../../../components/date-time-display';

class EmergencyStopPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      settings: {},
      submitting: false,
      showModal: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.cancel = this.cancel.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  openModal() {
    this.setState({ showModal: true });
  }

  confirm() {
    this.setState({ submitting: true, showModal: false }, () => {
      this.props.dispatch(updateEmergencySettings(!this.state.settings.disabled))
        .then(
          (settings) => {
            const disabled = settings.disabled === true;
            const el = (<div>{disabled ? 'All Automation Groups are disabled' : 'All Automation Groups are restored'}</div>);
            this.context.addNotification(el, { type: disabled ? 'error' : 'success', autoClose: true });
            this.setState({ submitting: false, settings });
          },
          (e) => {
            const el = (<div>{e.data?.message}</div>);
            this.context.addNotification(el, { type: 'error', autoClose: true });
            this.setState({ submitting: false });
          },
        );
    });
    
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  cancel() {
    this.setState({
      showModal: false,
    });
  }

  onToggle() {
    // this.setState({ disabled: !this.state.disabled }, () => {
      
    //});
    this.openModal();
  }

  componentDidMount() {
    this.setState({ loading: true, loaded: false, settings: {} }, () => {
      this.loadSettings();
    });
  }

  loadSettings() {
    this.props.dispatch(fetchEmergencySettings())
      .then(
        (settings) => {
          this.setState({ loading: false, loaded: true, settings });
        },
        (e) => {
          this.setState({ loading: false, loaded: false, settings: {} });
        },
      );
  }
  
  rernderModal() {
    const { showModal, submitting, settings } = this.state;
    const isCurrentlyDisabled = settings.disabled === true;

    const title = isCurrentlyDisabled ? 'Restore Automation Groups Confirmation' : 'Emergency Stop Confirmation';

    return (
      <Modal key="modal" show={showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            {isCurrentlyDisabled && 
              <div>
                <p>Are you sure you want to enable all automation groups and reminder email automation groups for all clients?</p>
              </div>
            }
            {!isCurrentlyDisabled && 
              <div>
                <p>Are you sure you want to disable all automation groups and reminder email automation groups for all clients?</p>
              </div>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button disabled={submitting} className="pull-left" bsStyle="default" onClick={this.cancel}>Cancel</Button>
            <Button disabled={submitting} className="pull-right" bsStyle={isCurrentlyDisabled ? 'success' : 'danger'} onClick={this.confirm}>{isCurrentlyDisabled ? 'Yes, Restore All Automation Groups' : 'Yes, Disable all automation groups'}</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderUpdatedInfo() {
    const { settings } = this.state;
    if (settings.updated_by && settings.updated_at) {
      return (
        <div className="text-muted">
          <p />
          <p>Last updated by {settings.updated_by} at <DateTimeDisplay format="shortWithTime" value={settings.updated_at} /></p>
        </div>
      );
    }
    return null;
  }


  render() {
    const { loading, disabled, submitting, settings } = this.state;

    return (
      <div>
        <Helmet title="Emergency Stop" />
        <p />
        <div className="container">
          <div className="well">
            <p><strong>Global Emergency Automation Group Override Controls</strong></p>
            <p>Use the following controls to disable, and subsequently enable, automation groups and reminder email automation groups for all clients.</p>
            {false && <p>Use these controls in emergency situations when we need to quickly turn off automation groups and reminder email automation groups for all active clients. When automation is disabled globally, TruSales saves a snapshot of the current status of all automation groups and then disables all automation groups across all clients. When you turn automation groups back on for all clients, TruSales uses the previously saved snapshot to set the status of all automation groups to the state they were in prior to the emergency stop control being used.</p>}
            

            {loading && <ProgressBar2 />}
            {!loading &&
              <div>
                <FormGroup>
                  <ControlLabel>Emergency Stop:</ControlLabel>
                  <div>
                    <Toggle
                      onClick={this.onToggle}
                      on={<span>ON</span>}
                      off={<span>OFF</span>}
                      size="xs"
                      onstyle="danger"
                      offstyle="success"
                      active={settings.disabled}
                      disabled={submitting}
                    />
                    {settings.disabled && 
                      <div className="text-danger"><Fa name="exclamation-triangle" /> All client automation groups are disabled.</div>
                    }
                    {!settings.disabled && 
                      <div className="text-success"><Fa name="check-circle" /> Automation running normally based on current client settings.</div>
                    }
                    {this.renderUpdatedInfo()}
                  </div>
                </FormGroup>
                {this.rernderModal()}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

EmergencyStopPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

EmergencyStopPage.defaultProps = {
};

EmergencyStopPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(EmergencyStopPage);
